// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3b93B","title":"Header_title__3hhAi","side":"Header_side__2h-gW"};